<template>
  <div class="chart-box">
    <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :style="myStyles"
    />
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";
import moment from "moment";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
);

export default {
  name: "BarChart",
  components: {
    Bar,
  },
  props: {
    chartData: {
      type: Object,
      default: () => {},
    },
    chartId: {
      type: String,
      default: "mood-bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 300,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    myStyles() {
      return {
        height: "800px",
        width: "100%",
      };
    },
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            anchor: "end",
            align: "end",
            display: true,
            font: {
              weight: "bold",
              size: 10,
            },
          },
        },
        scales: {
          x: {},
          y: {
            beginAtZero: true,
            ticks: {
              callback: function (value) {
                function formatDates(date) {
                  return moment(date).format("DD MMM YYYY");
                }

                const dataset = this.chart.config.data.datasets[0];
                this.chart.config.data.labels.map((date, index) => {
                  this.chart.config.data.labels[index] = formatDates(date);
                });

                this.chart.config.data.datasets.map((data, index) => {
                  this.chart.config.data.datasets[index].data.map(
                    (chartData, indexTwo) => {
                      if (
                        this.chart.config.data.datasets[index].data[
                          indexTwo
                        ] === 0
                      ) {
                        this.chart.config.data.datasets[index].data.splice(
                          indexTwo,
                          1,
                        );
                        this.chart.config.data.datasets[
                          index
                        ].backgroundColor.splice(indexTwo, 1);
                        this.chart.config.data.labels.splice(indexTwo, 1);
                      }
                    },
                  );
                });

                const label = dataset.label;

                if (label === "Session Distance") {
                  dataset.label = "Total Distance";
                }
                const labelText = value;
                return `${labelText}`.trim();
              },
            },
          },
        },
      },
    };
  },
  methods: {},
};
</script>
